"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokens = void 0;
var _globalTokens = require("../../../shared/global-tokens");
var tokens = exports.tokens = {
  border: {
    default: "border: ".concat(_globalTokens.globalBorder.width.thin, " solid ").concat(_globalTokens.globalColor.border.separator, ";")
  }
};